import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import Filter from './filter'
import EntityTypeId = com.eidu.entity.type.EntityTypeId

type GetEntityCountParameters = {
  typeId: EntityTypeId
  query?: string
  filters?: Filter[]
  signal?: AbortSignal
}

const getEntityCount = async ({ typeId, query, filters, signal }: GetEntityCountParameters): Promise<number> => {
  const params = new URLSearchParams()

  if (query) {
    params.append('query', query)
  }

  filters?.forEach((f) => params.append('filter', `${f.fieldId}:${f.value}`))

  const response = await fetchAuthorized(
    (authContext) =>
      `${entityApiUrl}/organizations/${authContext.organizationId}/types/${typeId.toString()}/entities/count?${params.toString()}`,
    {
      headers: {
        Accept: 'application/json',
      },
      signal,
    }
  )

  switch (response.status) {
    case 200: {
      const data = await response.json()
      return data.count
    }
    case 401:
    case 403:
      return 0
    default:
      throw Error(`Unexpected response code ${response.status} from getEntityCount endpoint`)
  }
}

export default getEntityCount
